import { doc, getDoc, onSnapshot, serverTimestamp, setDoc } from "firebase/firestore";
import { deleteObject, getDownloadURL, ref, uploadBytes } from "firebase/storage";
import { auth, dbAccounts, storage } from "../../../../backend/firebaseConfig";

const COLLECTION_NAME = "MonthlyQuilterStatements";

const validateMonth = (month) => {
  if (!/^\d{4}-\d{2}$/.test(month || "")) throw new Error("Select a valid statement month.");
};

export const subscribeQuilterStatement = (month, onData, onError) => {
  validateMonth(month);
  return onSnapshot(
    doc(dbAccounts, COLLECTION_NAME, month),
    (snapshot) => onData(snapshot.exists() ? { id: snapshot.id, ...snapshot.data() } : null),
    onError,
  );
};

export const getQuilterStatement = async (month) => {
  validateMonth(month);
  const snapshot = await getDoc(doc(dbAccounts, COLLECTION_NAME, month));
  return snapshot.exists() ? { id: snapshot.id, ...snapshot.data() } : null;
};

export const saveQuilterStatement = async ({ month, file, headers, rows, previousStoragePath = "" }) => {
  validateMonth(month);
  if (!file) throw new Error("Select a statement to upload.");
  if (!headers?.length || !rows?.length) {
    throw new Error("The selected file does not contain any statement entries.");
  }

  const extension = file.name.split(".").pop()?.toLowerCase() || "xlsx";
  const storagePath = `MonthlyQuilterStatements/${month}/quilter-statement.${extension}`;
  const storageReference = ref(storage, storagePath);
  await uploadBytes(storageReference, file, {
    contentType: file.type || "application/octet-stream",
    contentDisposition: `attachment; filename="${file.name.replace(/["\r\n]/g, "")}"`,
    customMetadata: { statementMonth: month },
  });
  const fileUrl = await getDownloadURL(storageReference);
  if (previousStoragePath && previousStoragePath !== storagePath) {
    await deleteObject(ref(storage, previousStoragePath)).catch(() => {});
  }

  const user = auth.currentUser;
  await setDoc(doc(dbAccounts, COLLECTION_NAME, month), {
    month,
    fileName: file.name,
    fileUrl,
    storagePath,
    fileContentType: file.type || "",
    fileSize: Number(file.size) || 0,
    headers,
    rows,
    rowCount: rows.length,
    uploadedAt: serverTimestamp(),
    uploadedBy: {
      uid: user?.uid || "",
      email: user?.email || "",
      name: user?.displayName || user?.email || "",
    },
  }, { merge: true });
};

export const saveQuilterAdviserLinks = async (month, adviserLinks) => {
  validateMonth(month);
  await setDoc(doc(dbAccounts, COLLECTION_NAME, month), {
    adviserLinks,
    adviserLinksUpdatedAt: serverTimestamp(),
  }, { merge: true });
};
